"use client";

import { c as _c } from "react/compiler-runtime";
import AblyChatProvider from "@/components/providers/AblyChatProvider";
import { PostHogIdentify } from "@/components/providers/PostHogIdentify";
import { CommandPalette } from "@/components/search/CommandPalette";
import { SupportIdentify } from "@/components/providers/SupportIdentify";
import { B3_AUTH_COOKIE_NAME } from "@/lib/constants/cookies";
import { useColorMode } from "@chakra-ui/react";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

/**
 * Force light mode on all (public) routes for unauthed visitors, and on the
 * "pure marketing" subset for everyone (including authed users who've toggled
 * dark). Dual-use pages (/templates, /integrations, /w/*) only honor the saved
 * Chakra color-mode preference when the visitor is signed in — Chakra's
 * hardcoded `initialColorMode: "dark"` would otherwise force fresh / referral
 * visitors into dark mode. Mirrors the inline pre-paint script in
 * app/(public)/layout.tsx.
 */
function ForceLightOnMarketing() {
  const $ = _c(11);
  const pathname = usePathname();
  const {
    colorMode,
    setColorMode
  } = useColorMode();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname === "/" || pathname === "/pricing" || pathname === "/agents" || pathname === "/about" || pathname === "/company" || pathname === "/contact" || pathname.startsWith("/blog") || pathname.startsWith("/solutions") || pathname.startsWith("/use-cases") || pathname.startsWith("/customers") || pathname.startsWith("/authors");
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isMarketing = t0;
  let t1;
  if ($[2] !== colorMode || $[3] !== isMarketing || $[4] !== setColorMode) {
    t1 = () => {
      const hasAuthCookie = typeof document !== "undefined" && document.cookie.split("; ").some(_temp);
      const forceLight = isMarketing || !hasAuthCookie;
      if (!forceLight) {
        return;
      }
      if (colorMode !== "light") {
        setColorMode("light");
      }
      const html = document.documentElement;
      html.classList.remove("dark", "theme-dark");
      html.setAttribute("data-theme", "light");
      html.style.colorScheme = "light";
    };
    $[2] = colorMode;
    $[3] = isMarketing;
    $[4] = setColorMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== colorMode || $[7] !== isMarketing || $[8] !== pathname || $[9] !== setColorMode) {
    t2 = [pathname, isMarketing, colorMode, setColorMode];
    $[6] = colorMode;
    $[7] = isMarketing;
    $[8] = pathname;
    $[9] = setColorMode;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useEffect(t1, t2);
  return null;
}
function _temp(c) {
  return c.startsWith(`${B3_AUTH_COOKIE_NAME}=`);
}
export default function PublicProviders(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PostHogIdentify />;
    t2 = <SupportIdentify />;
    t3 = <ForceLightOnMarketing />;
    t4 = <CommandPalette />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children) {
    t5 = <AblyChatProvider>{t1}{t2}{t3}{t4}{children}</AblyChatProvider>;
    $[4] = children;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}